import { useState } from "react";

import { Box, Modal } from "@mui/material";
import LogoGaBig from "../../assets/images/ga/logo-ga-big.png";
import SipLongLogo from "../../image/sip_long_logo.png";
import CricoLogo from "../../assets/images/crico/crico_expanded_view_logo.png";
import ParentLinkStepperContainer from "./ParentLinkStepperContainer";
import { Product } from "../../util/Utils";
import { THEME } from "../../util/LookupConst";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  height: "90%",
  overflowY: "scroll",
  p: 2,
};

const ParentLinkStudentRegistration = () => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="center">
            <img
              src={
                Product.ProductCode() === THEME.GA
                  ? LogoGaBig
                  : Product.ProductCode() === THEME.SA
                  ? SipLongLogo
                  : CricoLogo
              }
              style={{ height: "54px" }}
              alt="Logo"
            />
          </div>
          <ParentLinkStepperContainer parentInfoClose={handleClose} />
        </Box>
      </Modal>
    </div>
  );
};

export default ParentLinkStudentRegistration;
